export default "__VITE_ASSET__ekKsLwal__"